import { render, staticRenderFns } from "./Y67TAlerts.vue?vue&type=template&id=cef77206&scoped=true&"
import script from "./Y67TAlerts.vue?vue&type=script&lang=js&"
export * from "./Y67TAlerts.vue?vue&type=script&lang=js&"
import style0 from "./Y67TAlerts.vue?vue&type=style&index=0&id=cef77206&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef77206",
  null
  
)

export default component.exports